import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { CurrencyPipe } from '@angular/common';
import { environment } from "../../../environments/environment";

@Component({
  selector: 'app-done',
  standalone: true,
  imports: [
    MatIconModule,
    CommonModule
  ],
  providers: [CurrencyPipe],
  templateUrl: './done.component.html',
  styleUrls: ['./done.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class DoneComponent implements OnInit, OnDestroy {
  iosLinke = '';
  androidLinke = '';
  ios: any = {
    akps: 'https://apps.apple.com/us/app/akpain-spine/id6471281069',
    MyPainSolution: 'https://apps.apple.com/us/app/mypainsolution/id6474763802',
  }
  android: any = {
    akps: 'https://play.google.com/store/apps/details?id=com.akps.akpsapp',
    MyPainSolution: 'https://play.google.com/store/apps/details?id=com.mypainsolution.mypainsolutionapp',
  }
  private destroySubject = new Subject<void>();

  consentsFormsIncomplete: boolean = false;
  doneIcon: string = 'healent-ios-checkmark-circle';
  doneTitle: string = 'Done!';
  doneBody: string = 'Your form and payment have been completed. Additional or incomplete forms may be needed at the clinic.';
  blinkIcon: boolean = false;
  isReactNative: boolean = false;
  remainingBalance: number = 0;
  displayRemainingBalance: string = '';
  isWebLogin: boolean = false;

  constructor(private route: ActivatedRoute, private currencyPipe: CurrencyPipe) { }

  ngOnInit(): void {
    const isWebview = localStorage.getItem('is_react_native_webview') === 'true';
    this.isReactNative = isWebview;
    this.route.queryParams.subscribe((params) => {
      this.isWebLogin = params['weblogin'] === 'true' || params['weblogin'] === true; // Handle string or boolean
      this.consentsFormsIncomplete = params['consents_forms_incomplete'] === 'true';
      if (this.consentsFormsIncomplete) {
        this.doneIcon = 'healent-warning';
        this.blinkIcon = true;
        this.doneTitle = 'Consents Incomplete';
        this.doneBody = 'Required consent forms must be signed at the front desk to see your physician.\n\n<span class="done-disclaimer">Note</span> Additional or incomplete forms may be needed at the clinic.';
      }
      
      this.remainingBalance = parseFloat(params['remainingBalance'] || '0') || 0;
      if (this.remainingBalance > 0) {
        this.displayRemainingBalance = this.currencyPipe.transform(this.remainingBalance, 'USD', 'symbol', '1.2-2') || '$0.00';
      }
    });
    const hospital_slug = localStorage.getItem('providerName') || '';
    this.iosLinke = this.ios[hospital_slug] || '';
    this.androidLinke = this.android[hospital_slug] || '';
    const providerName = localStorage.getItem('providerName');

    if (providerName) {
      document.body.classList.add(`provider-${providerName}`);
    }
  }

  ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
  sendClose(): void {
    if (this.isWebLogin) {
      const domain = environment.API_DOMAIN_LEGACY || 'dev.healent.com';
      window.location.href = `https://${domain}/forms`;
      return;
    }
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ flag: 'Back-home' }));
    }
  }

  sendLogout(): void {
    if (this.isWebLogin) {
      const domain = environment.API_DOMAIN_LEGACY || 'dev.healent.com';
      window.location.href = `https://${domain}/login`;
      return;
    }
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ flag: 'logout' }));
    }
  }
}
